export default {"src":"/_next/static/media/about3.ac96445a.svg","height":246,"width":280};